import React from "react";
import PropTypes from "prop-types";
import styles from "./picture.module.scss";

const Picture = (props) => {
  const {
    image,
    align,
    imageId,
    imageAlt,
    isDashboard,
    handleShowImage,
    handleDeleteImage,
  } = props;

  const handlePreventImageDrag = (event) => {
    event.preventDefault();
  };

  return (
    <div className={styles.squareContainer} style={{ textAlign: align }}>
      <div className={styles.squareImageContainer}>
        {image && (
          <img
            src={image}
            id={imageId}
            alt={imageAlt}
            draggable="false"
            onClick={handleShowImage}
            style={{ cursor: "pointer" }}
            onMouseDown={handlePreventImageDrag}
          />
        )}
      </div>
    </div>
  );
};

Picture.propTypes = {
  image: PropTypes.string,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      imageUrl: PropTypes.string,
    })
  ),
  imageAlt: PropTypes.string.isRequired,
  imageId: PropTypes.string.isRequired,
  handleRemoveItemFirebase: PropTypes.func,
};

Picture.defaultProps = {
  image: "",
  images: null,
  imageId: "",
  imageStyles: {},
  handleClick: () => {},
  handleRemoveItemFirebase: null,
};

export default Picture;
